import styled, { css } from "styled-components";

export type BadgeType = "top-creator";

interface Props {
  type: BadgeType;
}

export const Badge: React.VFC<Props> = ({ type }) => {
  const getBadgeIcon = () => {
    switch (type) {
      case "top-creator":
        return <>trophy</>;
      default:
        return null;
    }
  };

  const getBadgeText = () => {
    // TODO: useTranslation hook for internationalization
    switch (type) {
      case "top-creator":
        return "Top Creator";
      default:
        return "Unknown Badge Type";
    }
  };

  return (
    <Container $type={type}>
      {getBadgeIcon()}
      {getBadgeText()}
    </Container>
  );
};

const styles: Record<BadgeType, any> = {
  "top-creator": css`
    background-color: ${({ theme }) => theme.colors.redesign.p10};
    color: ${({ theme }) => theme.colors.redesign.p100};
  `,
};

const Container = styled.span<{ $type: BadgeType }>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 11px;
  padding: 4px 8px;
  border-radius: 4px;

  ${({ $type }) => styles[$type]}
`;
